import type { Guide, GuideRecordHint } from '../types';

/**
 * S-24.10-05 — okna klienta jako nawiasy Z/R na wykresach FTL (scenariusz e2e 27; paczka p. Mariusza z 21.10,
 * decyzje 20.10 i 21.10). Rekordy: DEMO 027 z obsadzeniem DEMO/2026/10/G01 — trzy punkty, R2 z terminem z planu
 * kończącym się przed szacowanym rozładunkiem (czerwony nawias); dane: `e2e/setup/seed-e2e.ts`, `gantt2410`.
 */
const CAR: GuideRecordHint = {
  description: 'pojazd z obsadzeniem, którego zlecenie ma kilka punktów',
  listPath: '/cars',
};

const ORDER: GuideRecordHint = {
  description: 'zlecenie z kilkoma punktami rozładunku',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide', dzial: 'FTL' },
};

export const guide: Guide = {
  flagKey: 'ganttWindowBrackets',
  title: 'Okna klienta jako nawiasy Z i R na wykresach',
  whatItDoes:
    'Okno klienta nie jest już szerokim prostokątem linią przerywaną, tylko nawiasami w wierszu paska realizacji: nawias Z u góry obejmuje dozwolone położenie załadunku, nawias R u dołu — rozładunku, każdy w swoim kolorze; przy kilku punktach Z1, R1, R2. Okno przy punkcie to termin z planu TMS, a bez niego okno zlecenia od klienta. Chmurka podaje godziny i miejsce. Gdy szacowany załadunek albo rozładunek wypada poza oknem, nawias jest czerwony. Okno poza zakresem osi to nawias otwarty ze strzałką. Nawiasów nie da się przeciągać — pasek pozostaje szacunkiem. Tak samo na karcie pojazdu, na pasku nad rekomendacjami i przy każdym zleceniu w harmonogramie floty.',
  audience: ['planista FTL', 'Team Leader (planista główny)'],
  presentationItems: ['S-24.10-05'],
  steps: [
    {
      route: '/cars/:carId/show',
      record: CAR,
      target: 'ftl-realizacja-nawias-z-1',
      mockupTestId: 'ftl-realizacja-nawias-z-1',
      title: 'Nawias Z1 nad paskiem',
      description:
        'Nawias Z1 stoi u góry wiersza paska i obejmuje okno załadunku przy pierwszym punkcie. Chmurka podaje godziny w czasie polskim, miejsce, skąd okno (plan TMS albo okno klienta) i czy szacowany załadunek mieści się w oknie.',
      action: 'Na karcie pojazdu w „Harmonogramie” najedź na nawias nad paskiem zlecenia.',
      recorder: { account: 'master', demo: { kind: 'car', plate: 'DEMO 027' } },
    },
    {
      route: '/cars/:carId/show',
      record: CAR,
      target: 'ftl-realizacja-nawias-r-2',
      mockupTestId: 'ftl-realizacja-nawias-r-1',
      title: 'R1, R2 pod paskiem — czerwony przy kolizji',
      description:
        'Nawiasy rozładunku stoją u dołu, w innym kolorze. Tu R2 jest czerwony: okno rozładunku w Lipsku kończy się, zanim szacunek tam dojedzie — kolizja. Przy punkcie pośrednim (R1) zgodności nie oceniamy, bo czas postoju doliczamy przed trasą — chmurka to mówi.',
      action: 'Najedź na czerwony nawias pod paskiem i przeczytaj chmurkę.',
      recorder: { account: 'master', demo: { kind: 'car', plate: 'DEMO 027' } },
    },
    {
      route: '/fleet-schedule',
      target: 'ftl-realizacja-nawias-z-1',
      mockupTestId: 'ftl-realizacja-nawias-z-1',
      title: 'Harmonogram floty — nawiasy przy każdym zleceniu',
      description:
        'W harmonogramie floty nawiasy stoją przy każdym zleceniu, w trzech liniach wiersza pojazdu. Nazwa nawiasu i godziny są w chmurce, legenda pod osią objaśnia kolory.',
      action: 'Otwórz „Harmonogram floty” i najedź na nawias przy pasku zlecenia.',
      recorder: { account: 'master' },
    },
    {
      route: '/user-offers/:orderId/show',
      record: ORDER,
      target: 'order-timeline',
      title: 'Oś czasu zlecenia — te same nazwy',
      description:
        'Na karcie zlecenia oś czasu podaje okna punktów pod tymi samymi nazwami co nawiasy: Z1, R1, R2 — z miejscem i z informacją, czy to termin z planu TMS, czy okno zlecenia od klienta.',
      action: 'Na karcie zlecenia przewiń do „Osi czasu zlecenia”.',
      recorder: { account: 'master', demo: { kind: 'order', number: 'DEMO/2026/10/G01' } },
    },
  ],
};
